import styled from 'styled-components';

export const Container = styled.section`
  padding: 1.5rem;
  border-radius: 1.5rem;

  display: flex;
  flex-direction: column;
  row-gap: 2rem;

  background-color: ${props => props.theme.palette.neutral[100]};

  @media (max-width: ${props => props.theme.layout.breakpoints.md}) {
    padding: 0;
  }
`;
